import { FC } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { getIsActive, getQueryValue } from '@/utils'
import styles from './index.module.scss'

export const UserDetailNavbar: FC = () => {
  const router = useRouter()
  const username = getQueryValue('id', router)
  const items = [
    {
      label: 'Posts',
      href: `/users/${username}`,
      isActive: getIsActive(['/users/[id]'], router, true, true),
    },
    {
      label: 'Info',
      href: `/users/${username}/info`,
      isActive: getIsActive(['/users/[id]/info'], router, true, true),
    },
  ]

  return (
    <div className={styles.container}>
      {items.map((item) => (
        <div key={item.label} className={item.isActive ? styles.activeItem : styles.menuItem}>
          <div className={styles.enclose}>
            <Link href={item.href}>
              <a>{item.label}</a>
            </Link>
          </div>
        </div>
      ))}
    </div>
  )
}
